import { memo, useState } from "react";

import { Logout } from "@carbon/icons-react";
import { useNavigate } from "react-router-dom";

import { AppPathsEnum } from "@/constants/app.constants";
import { clearAuthToken } from "@/features/auth/api/auth";
import { authAction } from "@/features/auth/redux/auth.slice";
import { useAppDispatch, useAppSelector } from "@/redux/store";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import LogoutDialog from "../component/LogoutDialog";
import MyQR from "../component/MyQR";
import SettingSheet from "./SettingSheet";

const MenuSettingAccountPopup = () => {
  const user = useAppSelector((state) => state.auth.user);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    setLoading(true);
    await new Promise(() =>
      setTimeout(() => {
        dispatch(authAction.setUserData(null));
        clearAuthToken();
        navigate(AppPathsEnum.LOGIN);
      }, 1000)
    );
    setLoading(false);
    setOpenLogoutDialog(false);
  };

  return (
    <div className="w-[320px] bg-white rounded-xl overflow-hidden">
      {/* User Profile Section */}
      <div className="relative bg-gradient-to-br from-blue-50 via-white to-purple-50 p-6 text-center">
        {/* Background Pattern */}
        <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-blue-200/20 to-purple-200/20 rounded-full -translate-y-10 translate-x-10"></div>
        <div className="absolute bottom-0 left-0 w-16 h-16 bg-gradient-to-tr from-green-200/20 to-blue-200/20 rounded-full translate-y-8 -translate-x-8"></div>

        <div className="relative z-10">
          <Avatar className="h-20 w-20 mx-auto mb-4 ring-4 ring-white shadow-lg">
            <AvatarImage
              src={user?.photo || ""}
              className="object-cover"
            />
            <AvatarFallback className="bg-gradient-to-br from-blue-500 to-purple-600 text-white text-xl font-bold">
              {user?.email.slice(0, 2).toUpperCase()}
            </AvatarFallback>
          </Avatar>
          <h3 className="font-semibold text-gray-900 text-lg mb-1">
            {user?.name || "Người dùng"}
          </h3>
          <p className="text-sm text-gray-600 mb-2">{user?.email}</p>
        </div>
      </div>

      {/* Menu Items */}
      <div className="p-2">
        <MyQR />
        <SettingSheet />

        {/* Logout Button */}
        <button
          onClick={() => setOpenLogoutDialog(true)}
          className="w-full flex items-center gap-3 p-3 rounded-xl hover:bg-gray-50 transition-all duration-200 group"
        >
          <div className="p-2 rounded-lg bg-gray-50 group-hover:bg-gray-100 transition-colors text-gray-600">
            <Logout
              className="-scale-x-100"
              size={18}
            />
          </div>
          <span className="flex-1 text-left text-sm font-medium text-gray-700 group-hover:text-gray-900">
            Đăng xuất
          </span>
        </button>
      </div>

      {/* Footer */}
      <div className="px-4 py-3 bg-gray-50 border-t border-gray-100">
        <p className="text-xs text-gray-500 text-center">
          TAGA Professional Network v2.0
        </p>
      </div>

      <LogoutDialog
        open={openLogoutDialog}
        onClose={() => setOpenLogoutDialog(false)}
        loading={loading}
        onOk={handleLogout}
      />
    </div>
  );
};

export default memo(MenuSettingAccountPopup);
